import { BaseModel } from "../base.model";
import { PageContentFunction } from '@app/models/help/pagecontentfunction.model';

export class PageContent extends BaseModel {

  public id: number;
  public title: string;
  public image: string;
  public content: any;
  public searchHeader: string;
  public sectionId?: number;
  public pageContentFunctions:PageContentFunction[];

  constructor() {
    super();
    this.sectionId = null;
  }
}
